import { Spinner } from '@chakra-ui/react';

import type { JSX } from "react";

export const LoadingSpinner = (): JSX.Element => {
	return (
		<Spinner />
	);
};
